import * as React from 'react'
import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import { Check, CheckSquare, MinusSquare, Square } from '@phosphor-icons/react'
import { ComponentPropsWithRef } from 'react'
import { cn } from '@/lib/utils'

const Checkbox = ({ ref, className, ...props }: React.ComponentPropsWithRef<typeof CheckboxPrimitive.Root>) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      `ui-border-gray-200 ui-peer ui-h-4 ui-w-4 ui-shrink-0 ui-border ui-border-primary ui-ring-offset-background focus-visible:ui-outline-none focus-visible:ui-ring-2 focus-visible:ui-ring-ring focus-visible:ui-ring-offset-2 disabled:ui-cursor-not-allowed disabled:ui-opacity-50 data-[state=checked]:ui-bg-blue-400 data-[state=checked]:ui-text-white`,
      className
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator className={cn(`ui-flex ui-items-center ui-justify-center ui-text-current`)}>
      <Check size={12} weight='bold' />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
)
Checkbox.displayName = CheckboxPrimitive.Root.displayName

const MultiStateCheckbox = ({ className, ...field }: ComponentPropsWithRef<typeof CheckboxPrimitive.Root>) => (
  <CheckboxPrimitive.Root {...field} className={cn(`ui-peer ui-flex ui-justify-center ui-items-center`, className)}>
    <CheckboxPrimitive.Indicator className={cn(`ui-flex ui-items-center ui-justify-center ui-text-current`)}>
      {field.checked === true && <CheckSquare size={20} className={cn(`ui-text-blue-500`)} weight={`fill`} format={`outline`} />}
      {field.checked === `indeterminate` && <MinusSquare size={20} className={cn(`ui-text-blue-500`)} weight={`fill`} format={`stroke`} />}
    </CheckboxPrimitive.Indicator>
    {field.checked === false && <Square size={20} format='stroke' weight='light' className={cn(`ui-text-primary`)} />}
  </CheckboxPrimitive.Root>
)
MultiStateCheckbox.displayName = `MultiStateCheckbox`

export { Checkbox, MultiStateCheckbox }
